// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.attribute_code_visibility_enum */
var AttributeCodeVisibilityEnum;
(function (AttributeCodeVisibilityEnum) {
    AttributeCodeVisibilityEnum["PRIVATE"] = "PRIVATE";
    AttributeCodeVisibilityEnum["PUBLIC"] = "PUBLIC";
})(AttributeCodeVisibilityEnum || (AttributeCodeVisibilityEnum = {}));
;
export default AttributeCodeVisibilityEnum;
/** Zod schema for attribute_code_visibility_enum */
export const attributeCodeVisibilityEnum = z.nativeEnum(AttributeCodeVisibilityEnum);
//# sourceMappingURL=AttributeCodeVisibilityEnum.js.map